import { AviciIcon } from "@shared/assets/icons/grayscale/AviciIcon";
import meteoraIcon from "@shared/assets/icons/grayscale/meteora.svg";
import walletIcon from "@shared/assets/icons/grayscale/wallet.svg";
import React from "react";

import raydiumIcon from "../../../../../../../.claude/design-system/assets/logos/partners/raydium-mark-mono.svg";

interface BreakdownPool {
    pair: string;
    protocol: string;
    type: string;
}

/**
 * Per-protocol logo registry for breakdown rows. **One entry per
 * integrated protocol** — add the protocol's `pool.protocol` string and
 * its grayscale mark here as each integration ships. There is
 * intentionally no generic/placeholder mapping: an un-integrated
 * protocol has no logo and falls back to the colored graph-palette dot.
 */
const PROTOCOL_ICONS: Record<string, string> = {
    Meteora: meteoraIcon,
    Raydium: raydiumIcon
};

/**
 * Maps a breakdown row's pool to its grayscale protocol icon, or `null`
 * when no logo exists yet (caller falls back to the colored dot).
 *
 *   - Treasury / Wallet (the user's own USDv holding) → wallet mark
 *   - Avici (neobank)                                 → Avici mark
 *   - any protocol in {@link PROTOCOL_ICONS}          → its mark
 *   - everything else                                 → null (dot)
 */
export function breakdownIconFor(
    pool: BreakdownPool,
    className = "size-8 shrink-0"
): React.ReactNode | null {
    if (pool.type === "Treasury" || pool.type === "Wallet") {
        return (
            <img
                src={walletIcon}
                alt=""
                aria-hidden
                className={`${className} object-contain`}
            />
        );
    }
    if (pool.protocol === "Avici" || pool.type === "Neobank") {
        return <AviciIcon className={className} />;
    }
    const src = PROTOCOL_ICONS[pool.protocol];
    if (src) {
        return (
            <img
                src={src}
                alt=""
                aria-hidden
                className={`${className} object-contain`}
            />
        );
    }
    return null;
}
